const zipCodeRegex = /^\d{5}$/;
// only hyphens, parentheses, spaces, and numbers are allowed
const phoneNumberRegex = /^[\d()+\- ]+$/;

export { zipCodeRegex, phoneNumberRegex };
